import React from "react";
import { GetMoneyValue } from "../../../../../Api/ApiCommon";
import { IPay } from "../../../../../pages/Pay/PayInfo";
import { IPayMemberData } from "../PayInfoDetail";
import {
  PayDetailItem,
  PayDetailItemChildText,
  PayDetailItemGrayText,
  PayDetailItemText,
} from "./PartyFeePay";
import { getLPointShowValue } from "../../../../../ApiTS/ApiCommonTS";

interface PartyPenaltyPayProps {
  data: IPay;
  memberData: IPayMemberData[];
}

export default function PartyPenaltyPay({
  data,
  memberData,
}: PartyPenaltyPayProps) {
  console.log(memberData);

  return (
    <>
      {/* label */}
      <PayDetailItem>
        <PayDetailItemText>파티 위약금</PayDetailItemText>
        <>
          {memberData?.map((d: IPayMemberData, index: number) => (
            <PayDetailItemChildText key={index}>
              파티원_{d?.uid}
            </PayDetailItemChildText>
          ))}
        </>

        {data?.log?.point > 0 && (
          <PayDetailItemText>링키드 포인트 사용</PayDetailItemText>
        )}
      </PayDetailItem>

      {/* value */}
      <PayDetailItem>
        {/* 파티 위약금 */}
        <PayDetailItemText>
          {GetMoneyValue(data?.log?.amount)}
        </PayDetailItemText>
        <>
          {memberData?.map((d: IPayMemberData, index: number) => (
            <PayDetailItemGrayText key={index}>
              {GetMoneyValue(d?.fowner)}
            </PayDetailItemGrayText>
          ))}
        </>

        {data?.log?.point > 0 && (
          <PayDetailItemText>
            -{getLPointShowValue(data?.log?.point)}
          </PayDetailItemText>
        )}
      </PayDetailItem>
    </>
  );
}
